import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  updateTripLocation,
} from 'redux/actions'
import {
  tripDataById,
} from 'redux/reducers'

import Component from './component'

const mapStateToProps = (state, props) => ({
  tripData: tripDataById(state, props.tripId),
})

const mapDispatchToProps = dispatch => (
  bindActionCreators(
    {
      updateTripLocation,
    },
    dispatch
  )
)

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/EditTrip/LocationDates/index.js